<template>
  <div class="color-toggle-container space-x-8">
    <v-switch
      :color="findColor()"
      :input-value="value"
      :disabled="type === 'disabled'"
      height="10px"
      :hide-details="hideDetails"
      @change="onClick"
    />
    <label class="label-style" :style="`color: ${findColor()}`">{{ label }}</label>
  </div>
</template>

<script>
import { ColorToggleTypes } from '@/types'

export default {
  name: 'color-toggle-button',
  props: {
    type: {
      type: String,
      default: 'regular',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    findColor() {
      return this.type === ColorToggleTypes.SUCCESSFUL
        ? '#55A35D'
        : this.type === ColorToggleTypes.FAILED
          ? '#DB384C'
          : this.type === ColorToggleTypes.DISABLED
            ? '#979797'
            : '#666666'
    },
    onClick(event) {
      this.$emit('changeToggleValue', !this.value)
    },
  },
}
</script>

<style scoped>
.color-toggle-container {
  display: flex;
  gap: 0.2rem;
  width: fit-content;
  align-items: center;
}

.label-style {
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Source Sans Pro';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.space-x-8 {
  padding: 0 0.5rem;
}
</style>
